import { render, staticRenderFns } from "./ViewerMindmap.vue?vue&type=template&id=bf9835f8&scoped=true"
import script from "./ViewerMindmap.vue?vue&type=script&lang=js"
export * from "./ViewerMindmap.vue?vue&type=script&lang=js"
import style0 from "./ViewerMindmap.vue?vue&type=style&index=0&id=bf9835f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9835f8",
  null
  
)

export default component.exports